// extracted by mini-css-extract-plugin
export default {"waveform":"style__waveform___VYsnA"};